import { createFileRoute, Outlet } from "@tanstack/react-router";

import { createNoIndexHead } from "@/lib/seo";

export const Route = createFileRoute("/(portal)")({
  // No session, no app shell, no prerender: the portal is rendered entirely on
  // the client from a capability token in the URL.
  ssr: false,
  head: () => createNoIndexHead("Review posts · PostDaily"),
  component: RouteComponent,
});

/**
 * Bare shell for the tokenized client review portal. Deliberately carries none
 * of the authenticated app's providers or chrome (no workspace context, no
 * sidebar, no analytics identity) — the reviewer is not a PostDaily user.
 */
function RouteComponent() {
  return (
    <div className="min-h-svh bg-muted/30">
      <Outlet />
    </div>
  );
}
